import { useEffect, useState } from 'react';
import toast from '../../services/toast';
import CloseIcon from '../../assets/icons/CloseIcon';
import './ToastContainer.css';

const ToastContainer = () => {
    const [items, setItems] = useState([]);

    useEffect(() => toast.subscribe(setItems), []);

    if (items.length === 0) return null;

    return (
        <div className="toast-container">
            {items.map((item) => (
                <div key={item.id} className={`toast toast--${item.type}`} role="alert">
                    <span className="toast__indicator" />
                    <span className="toast__message">{item.message}</span>
                    <button
                        type="button"
                        className="toast__close"
                        onClick={() => toast.dismiss(item.id)}
                        aria-label="Close"
                    >
                        <CloseIcon className="toast__close-icon" />
                    </button>
                </div>
            ))}
        </div>
    );
};

export default ToastContainer;
